export default "__VITE_ASSET__d2ad2873__"